import { Component } from '@angular/core';

@Component({
  selector: 'app-form-of-pension-payment-info',
  templateUrl: './form-of-pension-payment-info.component.html',
  styleUrls: ['./form-of-pension-payment-info.component.scss']
})
export class FormOfPensionPaymentInfoComponent {

}
